export default __webpack_public_path__ + "static/media/gallery_07.d6fa66e6.jpg";